import React, { Component, Fragment } from 'react';
import HTMLReactParser from 'html-react-parser';
import Checkbox from '../checkbox';
import './styles/titleBody.css';

class TitleBody extends Component {
  handleOnClick = (event) => {
    let title = event.currentTarget;
    if (title.classList.contains('show')) {
      title.classList.remove('show');
    } else {
      title.classList.add('show');
    }
  }

  render() {
    return (
      <Fragment>
        <button className="TitleBody" style={{textAlign:"left",lineHeight:"1.5em",marginTop: "0.333em",borderTop:"1px solid #ccc",padding:"37px 17px 24px"}}
          onClick={this.handleOnClick}>
          {this.props.checked === "1"
            ?<Checkbox style={{display:"table-cell",verticalAlign:"top",paddingRight:"10px"}} width="37px" />
            :null}
            <div style={{display:"table-cell"}} className="arrow">
          {this.props.data.field_text_1.replace('&#039;', "'")}
          </div>
        </button>
        <div style={{margin:"0 24px"}}>{HTMLReactParser(this.props.data.field_longtext_1)}</div>
      </Fragment>
    );
  }
}

export default TitleBody;
